// extracted by mini-css-extract-plugin
export default {"content":"eK-z","lookName":"fK-z","shopTheLookContainer":"gK-z","productContainer":"hK-z","imageContainer":"iK-z","mainImage":"jK-z"};